import * as i0 from '@angular/core';
import { Injectable, Pipe, NgModule } from '@angular/core';
import { BaseYcState, RegisterYCState, BaseYCService, AttachYCState } from '@yourcause/common/state';
import { CommonModule } from '@angular/common';
import { YCCommonModule } from '@yourcause/common';

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let FeatureFlagState = class FeatureFlagState extends BaseYcState {
};
FeatureFlagState = __decorate$1([
    RegisterYCState()
], FeatureFlagState);

var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus[FeatureStatus["OFF"] = 1] = "OFF";
    FeatureStatus[FeatureStatus["CANARY"] = 2] = "CANARY";
    FeatureStatus[FeatureStatus["ON"] = 3] = "ON";
})(FeatureStatus || (FeatureStatus = {}));

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let FeatureFlagService = class FeatureFlagService extends BaseYCService {
    getFeatureFlagEnabled(flag) {
        const currentFlagValue = this.get('featureFlags')?.[flag];
        return currentFlagValue === FeatureStatus.ON || currentFlagValue === FeatureStatus.CANARY;
    }
    setFeatureFlags(featureFlags) {
        this.set('featureFlags', featureFlags);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureFlagService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureFlagService, providedIn: 'root' }); }
};
FeatureFlagService = __decorate([
    AttachYCState(FeatureFlagState)
], FeatureFlagService);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureFlagService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class FeatureFlagEnabledPipe {
    constructor(featureFlagService) {
        this.featureFlagService = featureFlagService;
    }
    transform(feature) {
        return this.featureFlagService.getFeatureFlagEnabled(feature);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureFlagEnabledPipe, deps: [{ token: FeatureFlagService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: FeatureFlagEnabledPipe, isStandalone: false, name: "ycFeatureFlagEnabled" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureFlagEnabledPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycFeatureFlagEnabled',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: FeatureFlagService }] });

class FeatureManagementModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureManagementModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: FeatureManagementModule, declarations: [FeatureFlagEnabledPipe], imports: [CommonModule,
            YCCommonModule], exports: [FeatureFlagEnabledPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureManagementModule, imports: [CommonModule,
            YCCommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FeatureManagementModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        YCCommonModule
                    ],
                    declarations: [
                        FeatureFlagEnabledPipe
                    ],
                    exports: [
                        FeatureFlagEnabledPipe
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FeatureFlagEnabledPipe, FeatureFlagService, FeatureManagementModule, FeatureStatus };
